"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var ModalFramePortal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ModalFramePortal, _React$Component);

  function ModalFramePortal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ModalFramePortal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ModalFramePortal).call(this, props));

    _this.renderSubtree = function () {
      var children = _this.props.children;

      _reactDom.default.unstable_renderSubtreeIntoContainer((0, _assertThisInitialized2.default)(_this), children, _this.modalNode);
    };

    _this.modalNode = document.createElement('div');
    return _this;
  }

  (0, _createClass2.default)(ModalFramePortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Append dom node at bottom of body and render modal inside
      // Use unstable_renderSubtreeIntoContainer if React 15
      document.body.appendChild(this.modalNode);

      if (!_reactDom.default.createPortal) {
        this.renderSubtree();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!_reactDom.default.createPortal) {
        this.renderSubtree();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_reactDom.default.createPortal) {
        _reactDom.default.unmountComponentAtNode(this.modalNode);
      }

      document.body.removeChild(this.modalNode);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;

      if (_reactDom.default.createPortal) {
        return _reactDom.default.createPortal(children, this.modalNode);
      }

      return null;
    }
  }]);
  return ModalFramePortal;
}(_react.default.Component);

var _default = ModalFramePortal;
exports.default = _default;
module.exports = exports.default;